export enum ComputedPaymentType {
    NewPaidAmount = 1,
    TaxDeduct = 2,
}
